export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';

export const SET_THEME = 'SET_THEME';

export const SET_SEARCH_PLACEHOLDER = 'SET_SEARCH_PLACEHOLDER';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SEARCH_INPUT_VALUE = 'SET_SEARCH_INPUT_VALUE';
export const RESET_SEARCHBAR = 'RESET_SEARCHBAR';

export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

export const SET_SELECTED_SIDEBAR_TAB = 'SET_SELECTED_SIDEBAR_TAB';
export const SET_SELECTED_DOCUMENT_TABLE = 'SET_SELECTED_DOCUMENT_TABLE';
export const SET_SELECTED_SUBDOCUMENT_TABLE = 'SET_SELECTED_SUBDOCUMENT_TABLE';
export const SET_SELECTED_SECTION = 'SET_SELECTED_SECTION';

export const GET_USER = 'GET_USER';

export const SET_UNSAVED_CHANGES = 'SET_UNSAVED_CHANGES';
